import Input from './Input'
import { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { IconName } from 'components/Icon'

export interface InputGroup {
  inputProps?: {
    name?: string
    id?: string
    error?: string
    maxLength?: number
    'data-test'?: string
  }
  className?: string
  title?: string
  component?: ReactNode
  textarea?: boolean
  isValid?: boolean
  required?: boolean
  id?: string
  onBlur?: (e: FocusEvent) => void
  disabled?: boolean
  errorMessage?: string
  name?: string
  value?: string
  defaultValue?: string
  onChange?: (e: any) => void
  type?: string
  placeholder?: string
  iconColour?: string
  icon?: IconName
  iconLeft?: IconName
  touched?: boolean
}

const InputGroup: FC<InputGroup> = ({
  className,
  component,
  defaultValue,
  disabled,
  errorMessage,
  icon,
  iconColour,
  iconLeft,
  id: _id,
  inputProps = {},
  isValid,
  name,
  onBlur,
  onChange,
  placeholder,
  required,
  textarea,
  title,
  touched,
  type,
  value,
}) => {
  //   Should I use useRef to connect focus with input?
  //   const focus = () => {
  //     input.focus();
  //   };

  const id = _id || inputProps.id || inputProps.name
  return (
    <div className={classNames(`form-group`, className)}>
      {title ? (
        <label className='form-label d-block' htmlFor={id}>
          {title}
          {required && <span className='color-pink5'>*</span>}
        </label>
      ) : null}

      <>
        {component ? (
          component
        ) : (
          <Input
            // ref={(c) => (this.input = c)}
            name={name}
            textarea={textarea}
            onBlur={onBlur}
            icon={icon}
            iconLeft={iconLeft}
            {...inputProps}
            isValid={isValid}
            disabled={disabled}
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            type={type || 'text'}
            id={id}
            placeholder={placeholder}
            iconColour={iconColour}
            touched={touched}
          />
        )}
      </>
      {errorMessage && (
        <div className='flex d-flex mt-1'>
          <div className='form-error-pipe' />
          <span
            id={inputProps.name ? `${inputProps.name}-error` : ''}
            className='color-danger'
          >
            <small>{errorMessage}</small>
          </span>
        </div>
      )}
    </div>
  )
}

InputGroup.displayName = 'InputGroup'
export default InputGroup
